const data = {
  data: {
    Respuesta: 0,
    blnError: false,
    codError: null,
    msgError: null
  }
}
  
export default data
